import 'react-app-polyfill/ie11.js';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    Locale,
    overrideComponent,
    postVerificationSizeUpdates,
    setMetadata,
    setOptions,
    setViewModel,
    StudentPersonalInfoViewModel,
} from '@sheerid/jslib';
import { StepSuccessComponent } from './components/steps/StepSuccessComponent';
import { StepErrorComponent } from './components/steps/StepErrorComponent';
import { AllowedCountries } from './lib/types/types';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { getQueryParamsByName } from './lib/utils/browser';
import { getRedirectUrl } from './lib/successUrlHelper';

overrideComponent('StepSuccessComponent', StepSuccessComponent);
// @ts-expect-error
overrideComponent('StepErrorComponent', StepErrorComponent);


const country = getQueryParamsByName('country') || '';
const locale = getQueryParamsByName('locale') || '';
const redirectUrl = getRedirectUrl();

if ((country !== 'AT' && country !== 'BE' && country !== 'DK' && country !== 'FI' && country !== 'FR' && country !== 'DE' && country !== 'IS' && country !== 'IE' && country !== 'IT' && country !== 'NL' && country !== 'ES' && country !== 'SE' && country !== 'CH' && country !== 'GB')) {
    // @ts-expect-error
    overrideComponent('StepStudentPersonalInfoComponent', StepErrorComponent);
}

const defaultViewModel: StudentPersonalInfoViewModel = {
    countryChoice: { value: country as AllowedCountries, label: '' },
    email: '',
    firstName: '',
    lastName: '',
    birthDate: '',
    localeChoice: { value: locale as Locale, label: undefined },
    organization: { id: 0, name: '' },
    metadata: {
    },
};

setViewModel(defaultViewModel);

setMetadata({ country, locale, redirectUrl });

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
